import { setUserProfile } from '../ducks';
import getLinks from '../utils/linksUtils';
import { parseResponse } from '../utils/utils';
import {
  NO_MATCHING_PROFILES,
  API_STATUS_200,
  API_METHOD_GET,
  API_STATUS_401,
} from '../constants';

function makeApiCall(url) {
  return (dispatch, getState, { fetchClient }) => {
    const options = {
      method: API_METHOD_GET,
      credentials: 'include',
    };
    return fetchClient(url, options);
  };
}

const redirect = (replace, nextState, statusCode) => {
  if (global.BROWSER) {
    switch (statusCode) {
      case API_STATUS_401:
        replace({ pathname: `${nextState.params?.scenario}/unauthorizedError` });
        break;
      default:
        replace({ pathname: `${nextState.params?.scenario}/error` });
        break;
    }
  }
};

const handleProfileResponse = async (profileResponse, dispatch) => {
  let userDetails = await profileResponse.json();
  userDetails = parseResponse({
    ...userDetails,
    email: userDetails.emailId,
    middleInitial: userDetails.middleName,
  });
  await dispatch(setUserProfile(userDetails));
  return null;
};

const useAtWorkAuth = (
  { dispatch, getState }
) => async (nextState, replace, callback) => {
  const state = getState();
  const currentEnv = state.getIn(['config', 'linkKey']);
  const reconLinks = getLinks('recon', currentEnv);
  const oneDataApiUrl = getState().getIn(['config', 'oneDataApiUrl']);

  try {
    const sessionResponse = await dispatch(makeApiCall(`${oneDataApiUrl}/ReadUserSession.v1`));
    const { status } = sessionResponse;
    if (status === API_STATUS_200) {
      if (nextState.location.pathname.includes(NO_MATCHING_PROFILES)) {
        const profileResponse = await dispatch(makeApiCall(`${reconLinks.reconAuthServiceUrl}user/getUserProfile`));
        const { status: profileStatus } = profileResponse;
        if (profileStatus === API_STATUS_200) {
          await handleProfileResponse(profileResponse, dispatch);
        } else {
          redirect(replace, nextState, profileStatus);
        }
      }
    } else {
      redirect(replace, nextState, status);
    }
    callback();
  } catch (error) {
    redirect(replace, nextState);
    callback();
  }
};

export default useAtWorkAuth;
